import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { BarLoader } from "react-spinners";

import { Wholesaler } from "../../../models/wholesaler";
import Page404 from "../page_404";
import { GETWHOLESAER } from "../promo/queries";

const redirects = [
  {
    from: "/purchaseplan",
    to: "/signin",
  },
  {
    from: "/youraccount",
    to: "/signin",
  },
  {
    from: "/creator_reader",
    to: "/signin",
  },
  {
    from: "/reader",
    to: "/signin",
  },
  {
    from: "/editprofile",
    to: "/signin",
  },
  {
    from: "/signin",
    to: "/",
  },
  {
    from: "/student_signin",
    to: "/",
  },
  {
    from: "/studentsignup",
    to: "/",
  },
  {
    from: "/signup",
    to: "/",
  },
  {
    from: "/google",
    to: "/",
  },
  {
    from: "/promo",
    to: "/",
  },
  {
    from: "/invite",
    to: "/",
  },
  {
    from: "/authors",
    to: "/",
  },
  {
    from: "/creators",
    to: "/",
  },
];

const SmartRedirect: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const query = useUrlQuery();
  const [getWholesaler, { data, loading: gettingWholesaler, called }] =
    useLazyQuery<{
      getWholesaer: Wholesaler;
    }>(GETWHOLESAER, {
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    const wholesaler_code = location.pathname.split("/").join("");
    getWholesaler({ variables: { code: wholesaler_code } });

    // Check if url is in redirects
    const pathParts = location.pathname.split("/");
    const firstPathPart = pathParts[1]; // Get the first part after the first slash
    const redirect = redirects.find((i) => {
      const redirectFrom = i.from.split("/")[1]; // Get the first part of the redirect path
      return redirectFrom === firstPathPart;
    });

    const url = query.get("url");
    if (redirect) {
      const currentPath = location.pathname;
      if (
        currentPath !== "/signin" &&
        currentPath !== "/student_signin" &&
        currentPath !== "/google"
      ) {
        localStorage.setItem("intendedPath", currentPath);
      }
      history.push({
        pathname: redirect.to,
      });
    } else if (url) {
      history.push({
        pathname: `/${url}`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]); // Add location.pathname as a dependency

  useEffect(() => {
    if (data) {
      history.push({
        pathname: `/invite/${data.getWholesaer.code}`,
      });
    } else if (gettingWholesaler === false && called) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, gettingWholesaler, called]);

  if (loading) {
    return (
      <main className="smart_redirect first-container full_page_loader">
        <img
          src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/Flangoo_logo_white512.png"
          alt="Flangoo Logo"
        />
        <p>Loading</p>
        <BarLoader color={"#fff"} />
      </main>
    );
  }
  return <Page404 />;
};

function useUrlQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

export default SmartRedirect;
